import gsap from 'gsap'
import Plyr from 'plyr'

import ee from '../ee'

class VideoFullWidth {
  constructor(el) {
    this.els_trigger = el.querySelectorAll('.js-video-full-width-play-cta')
    this.el_cover = el.querySelector('.js-full-width-cta-slide')
    this.el_video_container = el.querySelector('.js-video-container')
    this.el_video = el.querySelector('.js-video')
    this.video_player = null
    this.playTimeline = this.createPlayTimeline()
    this.pauseTimeline = this.createPauseTimeline()
    this.initVideo()
    this.addPlayHandlers()
  }

  addPlayHandlers() {
    this.els_trigger.forEach((el) => {
      el.addEventListener('click', this.play.bind(this))
    })

    this.el_cover.addEventListener('click', this.play.bind(this))
  }

  createPauseTimeline() {
    return gsap
      .timeline({
        paused: true,
        defaults: { duration: 0.3, ease: 'linear' },
      })
      .to(this.el_cover, { autoAlpha: 1 })
      .add(() => {
        this.el_cover.addEventListener('click', this.play.bind(this))
      })
  }

  createPlayTimeline() {
    return gsap
      .timeline({
        paused: true,
        defaults: { duration: 0.3, ease: 'linear' },
      })
      .to(this.el_cover, { autoAlpha: 0 })
      .add(() => {
        this.el_cover.removeEventListener('click', this.play.bind(this))
        this.video_player.play()
      })
  }

  initVideo() {
    this.video_player = new Plyr(this.el_video, {
      showPosterOnEnd: true,
    })

    this.video_player.on('ended', () => {
      this.pause()
    })
  }

  pause() {
    this.pauseTimeline.restart()
  }

  play(e) {
    e.preventDefault()
    this.playTimeline.restart()
  }
}

function init() {
  const videoFullWidthEls = document.querySelectorAll('.js-video-full-width')

  videoFullWidthEls.forEach((el) => {
    new VideoFullWidth(el)
  })
}

ee.addListener('initComponents', init)
